import { type FC } from 'react';
import { Center, Loader } from '@mantine/core';

export const AppLoader: FC = () => {
    return (
        <Center mih='100vh'>
            <Loader size='lg' />
        </Center>
    );
};
